import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { explainPick } from "../lib/api";

const Row = ({ label, text, color }) => (
  <div><span className="font-mono text-[10px] uppercase tracking-wider" style={{ color }}>{label}</span>
    <p className="text-xs text-[#cbd5e1] leading-relaxed">{text}</p></div>
);

export default function PickNote({ symbol, initial, id }) {
  const [note, setNote] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const run = async () => {
    setBusy(true); setErr("");
    try { setNote(await explainPick(symbol)); } catch (e) { setErr(e?.response?.data?.detail || "Could not generate"); } finally { setBusy(false); }
  };
  if (!note) {
    return (
      <div className="mt-3">
        <button data-testid={`scan-explain-${id}`} onClick={run} disabled={busy}
          className="flex items-center gap-1.5 text-xs text-[#a855f7] hover:text-[#c084fc] transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} {busy ? "Claude is writing…" : "Explain this pick (AI)"}
        </button>
        {err && <div className="text-[11px] text-[#ff3b30] mt-1">{err}</div>}
      </div>
    );
  }
  return (
    <div className="mt-3 rounded-lg border border-[#a855f7]/25 bg-[#a855f7]/5 p-3 space-y-2" data-testid={`scan-note-${id}`}>
      <div className="flex items-center gap-1.5 text-[10px] font-mono text-[#a855f7]"><Sparkles className="w-3 h-3" /> AI NOTE · CLAUDE SONNET 5.5</div>
      <Row label="Business" text={note.business} color="#00e5ff" />
      <Row label="Moat" text={note.moat} color="#00e676" />
      <Row label="Key risk" text={note.risk} color="#ff3b30" />
    </div>
  );
}
